import axios from './network';

export default {
    getModules(tab) {
        return axios.get("/modules", { params: { tab } })
    }
}